import { render, staticRenderFns } from "./input-skill-column.vue?vue&type=template&id=5b843f05&scoped=true&"
import script from "./input-skill-column.vue?vue&type=script&lang=js&"
export * from "./input-skill-column.vue?vue&type=script&lang=js&"
import style0 from "./input-skill-column.vue?vue&type=style&index=0&id=5b843f05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b843f05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b843f05')) {
      api.createRecord('5b843f05', component.options)
    } else {
      api.reload('5b843f05', component.options)
    }
    module.hot.accept("./input-skill-column.vue?vue&type=template&id=5b843f05&scoped=true&", function () {
      api.rerender('5b843f05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input-skill-column.vue"
export default component.exports